import { useLocation } from "react-router-dom";
import {
  LayoutDashboard, CalendarClock, CalendarDays, Users, Video, UserCheck,
  FileText, Pill, FlaskConical, MessageSquare, BadgeDollarSign, UserRound,
  Stethoscope, Briefcase,
} from "lucide-react";
import LuxSidebar from "./LuxSidebar";
import { useUnread } from "@/lib/useUnread";

const NAV = [
  { section: "Overview",  to: "/doctor",               label: "Dashboard",             icon: LayoutDashboard, tid: "doctor-nav-dashboard" },
  { section: "Schedule",  to: "/doctor/availability",  label: "Availability",          icon: CalendarClock,   tid: "doctor-nav-availability" },
  { section: "Schedule",  to: "/doctor/appointments",  label: "Appointments",          icon: CalendarDays,    tid: "doctor-nav-appointments" },
  { section: "Schedule",  to: "/doctor/waiting-room",  label: "Waiting Room",          icon: Users,           tid: "doctor-nav-waiting" },
  { section: "Care",      to: "/doctor/consultations", label: "Consultations",         icon: Video,           tid: "doctor-nav-consultations" },
  { section: "Care",      to: "/doctor/patients",      label: "Authorized Patients",   icon: UserCheck,       tid: "doctor-nav-patients" },
  { section: "Care",      to: "/doctor/clinical-docs", label: "Clinical Documentation",icon: FileText,        tid: "doctor-nav-clinical-docs" },
  { section: "Care",      to: "/doctor/prescriptions", label: "Prescriptions",         icon: Pill,            tid: "doctor-nav-prescriptions" },
  { section: "Care",      to: "/doctor/lab-orders",    label: "Lab Orders",            icon: FlaskConical,    tid: "doctor-nav-lab-orders" },
  { section: "Care",      to: "/doctor/messages",      label: "Messages",              icon: MessageSquare,   tid: "doctor-nav-messages" },
  { section: "Practice",  to: "/doctor/earnings",      label: "Earnings",              icon: BadgeDollarSign, tid: "doctor-nav-earnings" },
  { section: "Practice",  to: "/doctor/profile",       label: "Profile",               icon: UserRound,       tid: "doctor-nav-profile" },
];

// Mobile bottom tabs — one per left-rail section group.
const TABS = [
  { id: "Overview", to: "/doctor",               label: "Overview", icon: LayoutDashboard, tid: "doctor-tab-overview" },
  { id: "Schedule", to: "/doctor/appointments",  label: "Schedule", icon: CalendarDays,    tid: "doctor-tab-schedule" },
  { id: "Care",     to: "/doctor/consultations", label: "Care",     icon: Stethoscope,     tid: "doctor-tab-care" },
  { id: "Practice", to: "/doctor/earnings",      label: "Practice", icon: Briefcase,       tid: "doctor-tab-practice" },
];

function sectionForPath(pathname) {
  if (pathname === "/doctor" || pathname === "/doctor/") return "Overview";
  const match = NAV
    .filter((n) => n.to !== "/doctor" && pathname.startsWith(n.to))
    .sort((a, b) => b.to.length - a.to.length)[0];
  if (match) return match.section;
  if (pathname.startsWith("/doctor/chart") || pathname.startsWith("/doctor/results")) return "Care";
  return "Overview";
}

export default function DoctorNav() {
  const { clinical_total } = useUnread();
  const location = useLocation();
  const items = NAV.map((n) =>
    n.to === "/doctor/messages" ? { ...n, badge: clinical_total } : n);
  const tabs = TABS.map((t) => (t.id === "Care" ? { ...t, badge: clinical_total } : t));
  return <LuxSidebar items={items} subtitle="Clinical Portal" footer="Signed notes are immutable"
    testidPrefix="doctor-nav" homePath="/doctor"
    tabs={tabs} activeTabId={sectionForPath(location.pathname)} />;
}
